import { Loading } from "@/components/ui/loading";
import { RoutesRoute } from "@/modules/routes/routes/routes.route";
import { createFileRoute } from "@tanstack/react-router";
import "mapbox-gl/dist/mapbox-gl.css";

export const Route = createFileRoute("/routes/")({
	component: RoutesRoute,
	pendingComponent: Loading,
});
